<template>
  <div>
    <v-container>
      <v-layout row wrap justify-space-between>
        <v-flex xs2>
          <v-text-field
            v-model="gen"
            label="Generation"
          ></v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-text-field
            v-model="lanes"
            label="Lanes"
          ></v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-text-field
            v-model="interfaceType"
            label="Interface Type"
          ></v-text-field>
        </v-flex>
        <v-flex xs2>
          <choice-list :config="subTypeConfig"></choice-list>
        </v-flex>
      </v-layout>
    </v-container>
    <standard-actions
      @save="save"
      @cancel="cancel"
      @close="$emit('close')"
      :save-button="{ name: 'Submit', disabled: !canProceed }"
      :cancel-button="{ name: 'Back' }"
    ></standard-actions>
  </div>
</template>

<script>
import standardActions from '../standardActions'
import choices from '../../autocompletes/choices'

export default {
  name: 'storage',
  components: {
    'standard-actions': standardActions,
    'choice-list': choices
  },
  computed: {
    canProceed () {
      return this.gen && this.lanes && this.interfaceType && this.subTypeConfig.id > -1
    }
  },
  data () {
    return {
      gen: '',
      lanes: 0,
      interfaceType: '',
      subTypeConfig: {
        id: 0,
        label: 'Sub Type',
        appName: 'parts',
        modelName: 'expansion_card',
        fieldName: 'sub_type'
      }
    }
  },
  methods: {
    save () {
      const details = {
        gen: this.gen,
        lanes: this.lanes,
        interface: this.interfaceType,
        sub_type: this.subTypeConfig.id
      }
      this.$emit('save', details)
    },

    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>
